import styled from '@emotion/styled'
import { fonts } from '../../__styling/settings/fonts'
import { calcRem } from '../../__styling/style-functions/calc-rem'

export const StyledRewardsText = styled('text')({
    fontFamily: fonts.thewest.sansSerif,
    fontWeight: 700,
    fontSize: calcRem(20),
})
